import { GlobalSectionsEnum } from '@actassa/api';

export const RoutesDictionary: Record<GlobalSectionsEnum, string> = {
    [GlobalSectionsEnum.FORGOT_PASSWORD]: 'forgot-password',
    [GlobalSectionsEnum.LOGIN]: 'login',
    [GlobalSectionsEnum.LOGOUT]: 'logout',
    [GlobalSectionsEnum.NO_ACCOUNT]: 'no-account',
    [GlobalSectionsEnum.SELECT_APP]: 'select-app',
};
